'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.notification.types.sms', [])
  .config(function(notificationTypeConfigProvider) {
    notificationTypeConfigProvider.registerNotificationType({
      label: 'SMS',
      key: 'sms',
      addressTemplateUrl: require('./additionalFields.html'),
    });
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/notification/types/sms/sms.notification.type.module.js